var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFirefox = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 68,
    viewBox: "0 0 66 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.562 22.8123C62.13 19.3666 59.2252 15.6464 56.9505 14.4703C58.573 17.6125 59.6989 20.987 60.2882 24.4738L60.2941 24.5291C56.5679 15.239 50.2489 11.4933 45.0882 3.3367C44.8271 2.92428 44.566 2.51101 44.3118 2.07478C44.1664 1.82563 44.0499 1.60114 43.9487 1.3945C43.7346 0.980001 43.5697 0.541944 43.4572 0.089214C43.4573 0.0683228 43.4498 0.0481071 43.436 0.0324233C43.4222 0.0167396 43.4031 0.00668551 43.3823 0.00417905C43.362 -0.00139302 43.3406 -0.00139302 43.3203 0.00417905C43.316 0.00417905 43.3092 0.0118322 43.3041 0.0135329C43.299 0.0152336 43.288 0.0228867 43.2803 0.0262881L43.2931 0.00417905C35.0149 4.85117 32.2062 13.8241 31.9477 18.3122C28.6418 18.5395 25.4811 19.7577 22.8779 21.808C22.6063 21.5779 22.3224 21.3628 22.0275 21.1634C21.2766 18.535 21.2446 15.7531 21.9348 13.1081C18.8948 14.5808 16.1935 16.6685 14.0019 19.2391H13.9866C12.6805 17.5835 12.7723 12.1242 12.8471 10.9839C12.4607 11.1392 12.0919 11.335 11.7468 11.5681C10.5938 12.391 9.51584 13.3144 8.52567 14.3275C7.39734 15.4715 6.3668 16.7079 5.44485 18.0239C3.32598 21.0278 1.82312 24.4209 1.02303 28.0087L0.978811 28.2264C0.916736 28.5164 0.693094 29.9688 0.654828 30.2843C0.654828 30.3089 0.649726 30.3319 0.647175 30.3566C0.358683 31.856 0.179919 33.3745 0.112305 34.9L0.112305 35.0701C0.11953 43.3221 3.22206 51.2712 8.80672 57.3464C14.3914 63.4216 22.0518 67.1807 30.2741 67.881C38.4964 68.5813 46.6822 66.1717 53.2138 61.1284C59.7454 56.0852 64.1475 48.7752 65.5501 40.6432C65.6054 40.2181 65.6505 39.7971 65.6998 39.3677C66.3786 33.7573 65.6437 28.0662 63.562 22.8123ZM25.5769 48.6102C25.7308 48.6842 25.8754 48.7641 26.0335 48.8347L26.0565 48.8491C25.8966 48.7726 25.7367 48.6929 25.5769 48.6102ZM60.2967 24.5368V24.5053L60.3026 24.5402L60.2967 24.5368Z",
    fill: "url(#paint0_linear_13103_6699)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.562 22.8121C62.13 19.3665 59.2252 15.6462 56.9505 14.4702C58.573 17.6124 59.6989 20.9869 60.2882 24.4737V24.5052L60.2941 24.5401C62.8343 31.8092 62.4669 39.7789 59.2686 46.7835C55.4913 54.8882 46.3484 63.1953 32.037 62.7913C16.5734 62.3534 2.95502 50.8788 0.409077 35.8497C-0.0543639 33.4798 0.409077 32.2782 0.642073 30.3522C0.324235 31.8483 0.146875 33.3708 0.112305 34.8999L0.112305 35.0699C0.11953 43.322 3.22206 51.2711 8.80672 57.3463C14.3914 63.4214 22.0518 67.1806 30.2741 67.8809C38.4964 68.5812 46.6822 66.1716 53.2138 61.1283C59.7454 56.0851 64.1475 48.7751 65.5501 40.6431C65.6054 40.218 65.6505 39.797 65.6998 39.3676C66.3786 33.7572 65.6437 28.0661 63.562 22.8121Z",
    fill: "url(#paint1_radial_13103_6699)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.562 22.8121C62.13 19.3665 59.2252 15.6462 56.9505 14.4702C58.573 17.6124 59.6989 20.9869 60.2882 24.4737V24.5052L60.2941 24.5401C62.8343 31.8092 62.4669 39.7789 59.2686 46.7835C55.4913 54.8882 46.3484 63.1953 32.037 62.7913C16.5734 62.3534 2.95502 50.8788 0.409077 35.8497C-0.0543639 33.4798 0.409077 32.2782 0.642073 30.3522C0.324235 31.8483 0.146875 33.3708 0.112305 34.8999L0.112305 35.0699C0.11953 43.322 3.22206 51.2711 8.80672 57.3463C14.3914 63.4214 22.0518 67.1806 30.2741 67.8809C38.4964 68.5812 46.6822 66.1716 53.2138 61.1283C59.7454 56.0851 64.1475 48.7751 65.5501 40.6431C65.6054 40.218 65.6505 39.797 65.6998 39.3676C66.3786 33.7572 65.6437 28.0661 63.562 22.8121Z",
    fill: "url(#paint2_radial_13103_6699)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5471 26.6867C47.6185 26.7368 47.6848 26.787 47.752 26.8372C46.9241 25.3692 45.8936 24.0252 44.6907 22.8448C34.4474 12.5998 42.0062 0.631102 43.2809 0.0231022L43.2936 0.00439453C35.0155 4.85139 32.2067 13.8243 31.9482 18.3124C32.3326 18.2861 32.7136 18.2537 33.1064 18.2537C36.0437 18.2591 38.9271 19.0422 41.4636 20.5235C44 22.0047 46.099 24.1311 47.5471 26.6867Z",
    fill: "url(#paint3_radial_13103_6699)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.127 28.7323C33.0725 29.552 30.1763 32.3794 29.1635 32.3794C19.7918 32.3794 18.2705 38.0487 18.2705 38.0487C18.6855 42.8226 22.012 46.7546 26.0334 48.8345C26.217 48.9298 26.4033 49.0157 26.5895 49.0999C26.912 49.2427 27.2346 49.3748 27.5572 49.4961C28.9373 49.9845 30.3828 50.2634 31.8455 50.3235C48.2717 51.0939 51.4537 30.6804 39.5998 24.7569C42.3962 24.393 45.2282 25.0806 47.5464 26.6863C46.0983 24.1308 43.9993 22.0043 41.4629 20.5231C38.9264 19.0419 36.043 18.2588 33.1057 18.2534C32.7145 18.2534 32.3319 18.2857 31.9475 18.3121C28.6416 18.5393 25.4809 19.7576 22.8777 21.8079C23.3803 22.2331 23.9474 22.8011 25.1422 23.9788C27.3786 26.1821 33.1142 28.4644 33.127 28.7323Z",
    fill: "url(#paint4_radial_13103_6699)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.127 28.7323C33.0725 29.552 30.1763 32.3794 29.1635 32.3794C19.7918 32.3794 18.2705 38.0487 18.2705 38.0487C18.6855 42.8226 22.012 46.7546 26.0334 48.8345C26.217 48.9298 26.4033 49.0157 26.5895 49.0999C26.912 49.2427 27.2346 49.3748 27.5572 49.4961C28.9373 49.9845 30.3828 50.2634 31.8455 50.3235C48.2717 51.0939 51.4537 30.6804 39.5998 24.7569C42.3962 24.393 45.2282 25.0806 47.5464 26.6863C46.0983 24.1308 43.9993 22.0043 41.4629 20.5231C38.9264 19.0419 36.043 18.2588 33.1057 18.2534C32.7145 18.2534 32.3319 18.2857 31.9475 18.3121C28.6416 18.5393 25.4809 19.7576 22.8777 21.8079C23.3803 22.2331 23.9474 22.8011 25.1422 23.9788C27.3786 26.1821 33.1142 28.4644 33.127 28.7323Z",
    fill: "url(#paint5_radial_13103_6699)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3414 20.7117C21.6084 20.8818 21.8287 21.0298 22.0217 21.1633C21.2707 18.5348 21.2387 15.753 21.929 13.1079C18.889 14.5806 16.1877 16.6684 13.9961 19.2389C14.1568 19.2347 18.9375 19.1488 21.3414 20.7117Z",
    fill: "url(#paint6_radial_13103_6699)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.413787 35.8501C2.95718 50.8792 16.5781 62.3538 32.0417 62.7917C46.3531 63.1965 55.496 54.8886 59.2733 46.7839C62.4716 39.7793 62.839 31.8096 60.2988 24.5404V24.509C60.2988 24.4843 60.2937 24.4699 60.2988 24.4775L60.3048 24.5328C61.474 32.1664 57.5913 39.5619 51.5215 44.5628L51.5028 44.6053C39.6761 54.2372 28.358 50.4166 26.0671 48.8571C25.9073 48.7805 25.7474 48.7009 25.5875 48.6181C18.6921 45.3221 15.8434 39.0398 16.4539 33.6519C14.8171 33.6761 13.2084 33.225 11.8227 32.3534C10.437 31.4818 9.33387 30.2271 8.64687 28.7412C10.4569 27.6323 12.5208 27.0054 14.6419 26.9202C16.7629 26.8351 18.8704 27.2945 20.7635 28.2548C24.6665 30.0266 29.1078 30.2012 33.1378 28.7412C33.125 28.4733 27.3894 26.1901 25.153 23.9877C23.9583 22.81 23.3911 22.2428 22.8885 21.8168C22.6169 21.5867 22.3331 21.3716 22.0382 21.1722C21.8426 21.0387 21.6224 20.8941 21.3579 20.7207C18.954 19.1577 14.1733 19.2436 14.0151 19.2479H13.9998C12.6937 17.5922 12.7855 12.133 12.8604 10.9927C12.474 11.148 12.1051 11.3438 11.76 11.5769C10.607 12.3998 9.52905 13.3232 8.53888 14.3363C7.40651 15.477 6.3717 16.7107 5.44531 18.0242C3.32644 21.0281 1.82358 24.4211 1.02349 28.009C1.00733 28.0762 -0.163601 33.1953 0.413787 35.8501Z",
    fill: "url(#paint7_radial_13103_6699)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6921 22.8446C45.8953 24.0263 46.9258 25.3718 47.7534 26.8412C47.9345 26.9781 48.1037 27.1142 48.2474 27.246C55.7194 34.1338 51.8044 43.8703 51.5128 44.5634C57.5826 39.5624 61.4619 32.167 60.296 24.5334C56.5681 15.239 50.2491 11.4933 45.0884 3.3367C44.8273 2.92428 44.5663 2.51101 44.312 2.07478C44.1666 1.82563 44.0501 1.60114 43.9489 1.3945C43.7349 0.980001 43.5699 0.541944 43.4574 0.089214C43.4575 0.0683228 43.45 0.0481071 43.4362 0.0324233C43.4224 0.0167396 43.4033 0.00668551 43.3826 0.00417904C43.3622 -0.00139301 43.3408 -0.00139301 43.3205 0.00417904C43.3162 0.00417904 43.3094 0.0118322 43.3043 0.0135329C43.2992 0.0152336 43.2882 0.0228867 43.2805 0.0262881C42.0059 0.630887 34.4471 12.5996 44.6921 22.8446Z",
    fill: "url(#paint8_radial_13103_6699)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2423 27.242C48.0985 27.1102 47.9293 26.9741 47.7482 26.8372C47.681 26.787 47.6147 26.7369 47.5433 26.6867C45.2251 25.081 42.3932 24.3934 39.5968 24.7572C51.4506 30.6842 48.2703 51.0943 31.8424 50.3239C30.3797 50.2638 28.9342 49.9849 27.5541 49.4965C27.2315 49.3757 26.909 49.2436 26.5864 49.1002C26.4002 49.0152 26.2139 48.9301 26.0303 48.8349L26.0532 48.8494C28.3441 50.4132 39.6588 54.2338 51.4889 44.5976L51.5076 44.5551C51.8027 43.8663 55.7177 34.1273 48.2423 27.242Z",
    fill: "url(#paint9_radial_13103_6699)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2712 38.0487C18.2712 38.0487 19.7925 32.3795 29.1642 32.3795C30.1769 32.3795 33.0758 29.5521 33.1276 28.7323C29.0976 30.1923 24.6563 30.0178 20.7534 28.2459C18.8602 27.2857 16.7527 26.8262 14.6317 26.9114C12.5107 26.9965 10.4468 27.6234 8.63672 28.7323C9.32371 30.2182 10.4269 31.473 11.8126 32.3446C13.1982 33.2162 14.8069 33.6672 16.4438 33.6431C15.8332 39.0318 18.6819 45.3141 25.5774 48.6092C25.7313 48.6832 25.8759 48.7632 26.034 48.8337C22.0093 46.7546 18.6862 42.8226 18.2712 38.0487Z",
    fill: "url(#paint10_radial_13103_6699)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.562 22.8123C62.13 19.3666 59.2252 15.6464 56.9505 14.4703C58.573 17.6125 59.6989 20.987 60.2882 24.4738L60.2941 24.5291C56.5679 15.239 50.2489 11.4933 45.0882 3.3367C44.8271 2.92428 44.566 2.51101 44.3118 2.07478C44.1664 1.82563 44.0499 1.60114 43.9487 1.3945C43.7346 0.980001 43.5697 0.541944 43.4572 0.089214C43.4573 0.0683228 43.4498 0.0481071 43.436 0.0324233C43.4222 0.0167396 43.4031 0.00668551 43.3823 0.00417905C43.362 -0.00139302 43.3406 -0.00139302 43.3203 0.00417905C43.316 0.00417905 43.3092 0.0118322 43.3041 0.0135329C43.299 0.0152336 43.288 0.0228867 43.2803 0.0262881L43.2931 0.00417905C35.0149 4.85117 32.2062 13.8241 31.9477 18.3122C32.3321 18.2858 32.713 18.2535 33.1059 18.2535C36.0431 18.2589 38.9266 19.042 41.463 20.5232C43.9995 22.0045 46.0985 24.1309 47.5465 26.6865C45.2283 25.0807 42.3964 24.3932 39.6 24.757C51.4539 30.6839 48.2736 51.094 31.8457 50.3236C30.3829 50.2636 28.9374 49.9847 27.5573 49.4962C27.2348 49.3755 26.9122 49.2434 26.5896 49.1C26.4034 49.0149 26.2172 48.9299 26.0335 48.8347L26.0565 48.8491C25.8966 48.7726 25.7367 48.6929 25.5769 48.6102C25.7308 48.6842 25.8754 48.7641 26.0335 48.8347C22.0088 46.7547 18.6856 42.8227 18.2707 38.0488C18.2707 38.0488 19.792 32.3795 29.1637 32.3795C30.1764 32.3795 33.0753 29.5521 33.1271 28.7324C33.1144 28.4645 27.3788 26.1813 25.1423 23.9789C23.9476 22.8012 23.3804 22.234 22.8779 21.808C22.6063 21.5779 22.3224 21.3628 22.0275 21.1634C21.2766 18.535 21.2446 15.7531 21.9348 13.1081C18.8948 14.5808 16.1935 16.6685 14.0019 19.2391H13.9866C12.6805 17.5835 12.7723 12.1242 12.8471 10.9839C12.4607 11.1392 12.0919 11.335 11.7468 11.5681C10.5938 12.391 9.51584 13.3144 8.52567 14.3275C7.39734 15.4715 6.3668 16.7079 5.44485 18.0239C3.32598 21.0278 1.82312 24.4209 1.02303 28.0087L0.978811 28.2264C0.916736 28.5164 0.638671 29.9892 0.598705 30.3055C0.598705 30.2809 0.598705 30.3294 0.598705 30.3055C0.344374 31.8259 0.181946 33.3601 0.112305 34.9L0.112305 35.0701C0.11953 43.3221 3.22206 51.2712 8.80672 57.3464C14.3914 63.4216 22.0518 67.1807 30.2741 67.881C38.4964 68.5813 46.6822 66.1717 53.2138 61.1284C59.7454 56.0852 64.1475 48.7752 65.5501 40.6432C65.6054 40.2181 65.6505 39.7971 65.6998 39.3677C66.3786 33.7573 65.6437 28.0662 63.562 22.8123Z",
    fill: "url(#paint11_linear_13103_6699)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13103_6699",
    x1: 59.1997,
    y1: 10.5349,
    x2: 4.48905,
    y2: 63.3204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13103_6699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.6716 7.54649) scale(68.7057 68.7057)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_13103_6699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.566 35.6354) scale(68.7057 68.7057)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_13103_6699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.8495 -8.0451) scale(49.7744 49.7744)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_13103_6699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9662 53.5816) scale(32.7138 32.7138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_13103_6699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3201 30.0047) rotate(-13.5916) scale(17.3447 20.3063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_13103_6699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.6987 4.73545) scale(23.5343 23.5343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_13103_6699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1974 -10.1917) scale(100.41 100.41)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_13103_6699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7345 -4.6086) rotate(83.976) scale(73.593 48.2984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_13103_6699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1444 13.4528) scale(62.6878 62.6878)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_13103_6699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6925 17.1213) scale(68.6113 68.6113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_13103_6699",
    x1: 58.5424,
    y1: 10.2526,
    x2: 11.9891,
    y2: 56.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFirefox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/firefox.092cef82ca9569ec2241c7761e2ddfd5.svg";